<div *ngIf="isLoading">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>


<mat-card class="content-card">
  <div class="explanation">

    <b>Process description:</b><br />

    <ol>
      <li>Upload a file containing a column with header "publicToken" with the 9-digit tokens of the cards that should be marked for renewal</li>
      <li>A renewal batch is created, where you can download a "Generated CSV" for import in the portal.</li>
      <li>Upload the "Generated CSV" to the portal and get a "Renewal Results CSV"</li>
      <li>Select the according renewal batch and upload the "Renewal Results CSV" there. (Columns: publicToken, firstName, lastName, address, city, postCode, countryCode, telephone, email, status, error, pan, cvv, expire, activationCode</li>
      <li>The cards will have the new PAN and date of expiry set</li>
    </ol>

  </div>
</mat-card>


<mat-card class="content-card">
  <div>
    <b>Create a new renewal batch</b>
  </div>
  <app-file-upload *appHasRoles="['admin']" (upload)="onUpload($event)"></app-file-upload>
</mat-card>

<mat-card class="content-card">

  <app-mat-table-generator #table
                           tableName="cardActivationsImportsTable"
                           [columns]="columns"
                           [dataSource]="dataSource"
                           [multiselectEnabled]="multiselectEnabled()"
                           [viewLink]="getViewLink"
                           [useEmbededFilter]="false"
                           [rowClassCallback]="getRowClass"
                           [deleteEnabled]="deleteEnabled()">
  </app-mat-table-generator>
</mat-card>
